const es = {
  auth: {
    email: `Correo electrónico`,
    password: `Contraseña`,
    login: `Iniciar sesión`,
    logout: `Cerrar sesión`,
    create_an_account: `Crear una cuenta`,
    forgot_password: `¿Olvidó su contraseña?`,
  },
  logout: `cerrar sesión`,
  login: {
    title: `Iniciar sesión en TreePlotter Mobile`,
    greeting: `Hola, bienvenido de nuevo`,
    new_user: `¿Nuevo usuario?`,
  },
  tenant: 'cuenta',
  tenant_select_ui: 'Seleccionar cuenta',
  tenant_list_ui: 'Cuentas',
  tenant_switch_dialog_title: 'Seleccionar cuenta',
  tenant_switch_dialog_message: 'Por favor seleccione una cuenta para continuar',
  confirm: 'Confirmar',
  no_tenant_found: 'Ninguna cuenta encontrada.',
  no_tenant_found_error:
    'No se encontró ninguna cuenta. Esto es un error. Por favor, contacte con el servicio de asistencia a continuación.',
  error_pun_message: 'El servidor abrazó un árbol y se cayó.',
  error_reset_instruction:
    'Algo no está configurado correctamente.\nToque restablecer para solucionarlo.',
  error_contact_support_if_needed: 'Contacte con soporte si lo necesita',
  tenant_switched_simple: 'Su cuenta ha sido cambiada.',
  inventory: `Inventario`,
  organization: `Organización`,
  inspections: {
    start_basic_inspection: 'Iniciar Inspección Básica',
    submit: 'Enviar Inspección',
    inspection_details: 'Detalles de Inspección',
    tree_details: 'Detalles del Árbol',
    inspection_on: 'Inspección el {{date}}',
  },
  home: {
    greeting: `¡Hola!`,
    current_tenant: `Cuenta actual: `,
    my_location: `Mi Ubicación`,
    select_organization_required: `Por favor seleccione una organización para comenzar a plantar árboles.`,
    get_to_know_planitgeo: `Conoce PlanIT Geo`,
    help: `¿Cómo podemos ayudarte?`,
    chat: `Hagamos un chat.`,
    support: `Soporte`,
    contact_us: `Contacta con nosotros`,
  },
  map: {
    filter: `Filtro`,
    filter_sidebar_title: `Filtros de Mapa`,
    organizations: `Organizaciones`,
    select_organization: `Organización`,
    load: `Cargar`,
    close: `Cerrar`,
    display_by: `Mostrar por`,
    view_controls: `Controles de Vista del Mapa`,
    reference_layers: `Capas de Referencia`,
    base_map: `Mapa Base`,
    show_all_trees: `Mostrar Todos los Árboles`,
    filter_min: `Mín`,
    filter_max: `Máx`,
    filter_range_invalid: `El mínimo debe ser menor o igual que el máximo.`,
    coming_soon: `Próximamente`,
    legend: `Leyenda`,
    no_legend_data: `No hay datos disponibles.`,
    legend_additional_trees: `Sin coincidir`,
    legend_not_specified: `No especificado`,
    user_location: `Mi Ubicación`,
    filters_coming_soon: `Filtros próximamente`,
    move_asset: `Mover {{layerName}}`,
    move_asset_subtext: `Desplace el mapa para posicionar el pin, luego confirme.`,
    move_asset_select_first: `Toque un {{layerName}} para seleccionarlo y moverlo.`,
    move_asset_panel_title: `Mover {{layerName}} #{{id}}`,
    move_asset_panel_subtext: `Arrastre el mapa para colocar el pin.`,
    move_asset_confirm_title: `Confirmar Movimiento`,
    move_asset_confirm_message: `¿Mover {{layerName}} a esta ubicación?`,
    move_asset_success: `{{layerName}} movido exitosamente`,
    move_asset_refresh_failed: `{{layerName}} movido exitosamente, pero falló la actualización del mapa. Por favor, actualice la página.`,
    move_asset_error: `Falló al mover {{layerName}}`,
    move_asset_error_unexpected: `Ocurrió un error inesperado al mover {{layerName}}`,
    move_asset_cancelled: `Mover {{layerName}} cancelado`,
    load_last_asset: `Carga Masiva del Último`,
    load_last_asset_subtext: `Mantenga presionado para agregar {{layerName}} con los últimos datos.`,
    load_last_asset_error: `No se pudo crear {{layerName}} con los últimos datos cargados`,
    load_last_asset_no_data: `No hay datos de {{layerName}} cargados previamente disponibles`,
    load_last_asset_staged: `{{layerName}} agregado`,
    load_last_asset_flush_success: `{{count}} {{layerName}}(s) creado(s) con los últimos datos cargados`,
    load_last_asset_flush_error: `No se pudieron guardar los {{layerName}} agregados`,
    load_last_complete: `Completar`,
    load_last_cancel_title: `Cancelar Carga Masiva del Último`,
    load_last_cancel_message: `Esto eliminará {{count}} {{layerName}}(s) agregado(s).`,
    load_last_cancel_remove: `Eliminar`,
    load_last_cancel_keep: `Seguir Agregando`,
    add_asset: `Agregar {{layerName}}`,
    add_asset_subtext: `Mantén presionado en la ubicación del {{layerName}} para agregar.`,
    map_actions: `Acciones del Mapa`,
    tree: `Árbol`,
    work: `Trabajo`,
    priority: `Prioridad`,
    center_error: `No se pudo obtener el centro del mapa`,
    no_assets_match_filters: `Ningún activo coincide con los filtros seleccionados`,
    zoom_out: `Alejar`,
    clear_filters: `Limpiar Filtros`,
    showing_partial_matches: `{{shown}} de {{total}} tareas de trabajo disponibles`,
    dismiss: `Descartar`,
  },
  common: {
    close: `Cerrar`,
  },
  user: `usuario`,
  sync: {
    sync_data: 'Sincronizar Datos',
    sync_data_description:
      'Sincronizar datos entre sistemas para asegurar que todos los campos de TP2 estén disponibles. Esto resuelve cualquier referencia faltante y actualiza la base de datos con la información más reciente. Por favor, espere alrededor de 1 minuto, luego cierre sesión y vuelva a iniciar sesión para ver los cambios.',
    syncing: 'Sincronizando...',
    sync_complete: 'Sincronización en progreso, esto puede tomar unos segundos',
    sync_error: 'Error de Sincronización',
  },
  photos: {
    section_title: `Agregar Fotos`,
    error_adding_photos: `Error al agregar fotos`,
    unknown_error: `Se produjo un error desconocido`,
    file_too_large: `El archivo es demasiado grande. Por favor seleccione una imagen más pequeña.`,
    file_too_large_offline: `El archivo es demasiado grande para uso sin conexión. Conéctese a internet o seleccione una imagen más pequeña.`,
    save_first_title: `¡Guarde primero para agregar fotos!`,
    save_first_content: `Por favor, guarde primero el activo para cargar y administrar fotos. Esto garantiza que sus fotos estén correctamente vinculadas al activo correcto.`,
    save_first_button: `Guardar activo`,
    no_photos_linked: `No hay fotos vinculadas a este activo.`,
    loading_photos: `Cargando fotos...`,
    use_camera_or_library: `Usar cámara o biblioteca`,
    use_camera: `Cámara`,
    use_library: `Biblioteca`,
    choose_photo_source: `Elegir fuente de foto`,
    addPhotoAria: `Añadir foto`,
    delete_photo: `Eliminar foto`,
    delete_photo_prompt: `¿Está seguro de que desea eliminar esta foto? Esta acción no se puede deshacer.`,
    delete_photo_success: `Foto eliminada exitosamente`,
    delete_photo_error: `Error al eliminar la foto. Por favor, inténtelo de nuevo.`,
    failed_to_load: `Error al cargar la foto`,
    failed_to_load_image: `Error al cargar la imagen`,
    max_photos_reached: `Límite de fotos alcanzado`,
    offline_mode: `Modo sin conexión`,
    upload_pending_title: `CARGA DE FOTOS PENDIENTE`,
    upload_pending_content: `Tiene cargas de fotos pendientes. ¿Está seguro de que desea cerrar el formulario antes de que se completen estas cargas?`,
    unsaved_changes_title: `CAMBIOS NO GUARDADOS`,
    unsaved_changes_content: `Tiene cambios no guardados. ¿Está seguro de que desea cerrar el formulario?`,
    unsaved_changes_with_photos_title: `CAMBIOS NO GUARDADOS`,
    unsaved_changes_with_photos_content: `Tiene cambios no guardados y cargas de fotos pendientes. ¿Está seguro de que desea cerrar el formulario?`,
    work_task_photo: `Tarea de Trabajo`,
    inspection_photo: `Inspección`,
    view_photos: `Ver Fotos`,
    all_photos: `Todas las Fotos`,
    added_date: `Agregada {{date}}`,
    context_tree_details: `Detalles del árbol`,
    context_inspection: `Inspección`,
    context_work_task: `Tarea de trabajo`,
    no_photos: `Sin fotos`,
    previous: `Foto anterior`,
    next: `Foto siguiente`,
  },
  accessibility: {
    color_vision_accessibility: `Accesibilidad a la visión del color`,
    choose_color_palette: `Usar colores acromatopsia (escala de grises).`,
    default_colors: `Colores Predeterminados`,
    protanopia: `Protanopía (Ceguera al rojo)`,
    deuteranopia: `Deuteranopía (Ceguera al verde)`,
    tritanopia: `Tritanopía (Ceguera al azul)`,
    achromatopsia: `Acromatopsia (Ceguera completa al color)`,
  },
  fullscreen: {
    title: `Modo Pantalla Completa`,
    description: `Ocultar la barra de direcciones para una vista más limpia. No compatible con todos los navegadores.`,
    enter: `Pantalla Completa`,
    exit: `Salir de Pantalla Completa`,
    enabled: `Activado`,
    disabled: `Desactivado`,
    not_supported: `El modo pantalla completa no es compatible con este navegador`,
    error: `Error al entrar en modo pantalla completa`,
  },
  organizations: {
    no_organizations_available: `No hay organizaciones disponibles`,
    organizations_load_error: `Error al cargar las organizaciones`,
  },
  settings_screen: {
    greeting: '¡Hola!',
    current_app_version: 'Versión de la aplicación actual',
    version_information_unavailable: 'Información de versión no disponible',
  },
  data: {
    save: `Guardar`,
    load_last: `Cargar Último`,
    load_last_title: `Cargar Último Activo`,
    load_last_prompt: `¿Está seguro de que desea cargar el último activo cargado? Esto sobrescribirá todos los cambios no guardados.`,
    ignore_changes: `Ignorar Cambios`,
    ignore_changes_prompt: `Has elegido salir del formulario sin guardar los cambios. ¿Estás seguro?`,
    ignore_changes_with_photos: `Ignorar Cambios y Cargas Pendientes`,
    ignore_changes_with_photos_prompt: `Tienes cambios sin guardar y cargas de fotos pendientes. ¿Estás seguro de que quieres cerrar el formulario?`,
    save_changes: `Guardar Cambios`,
    save_changes_prompt: `Has elegido salir del formulario sin guardar los cambios. ¿Estás seguro?`,
    continue: `Continuar`,
    delete: `Eliminar`,
    cancel: `Cancelar`,
    create_successful: `{{title}} creado correctamente!`,
    create_error: `Error al crear {{title}}. Por favor, inténtelo de nuevo.`,
    update_successful: `{{title}} actualizado correctamente!`,
    update_error: `Error al actualizar {{title}}. Por favor, inténtelo de nuevo.`,
    create_queued: `{{title}} guardado. Se creará cuando vuelvas a estar en línea.`,
    update_queued: `{{title}} guardado. Los cambios se sincronizarán cuando vuelvas a estar en línea.`,
    queued_submit_failed: `No se pudieron enviar los cambios sin conexión (activo {{assetId}}). Por favor, inténtelo de nuevo.`,
    photo_link_failed: `No se pudo adjuntar la foto al activo {{assetId}}. Por favor, inténtelo de nuevo.`,
  },
  asset: {
    edit_error_title: `No se puede editar el activo`,
    edit_error_message: `Este activo aún se está cargando o le faltan datos requeridos. Por favor, inténtalo de nuevo en un momento.`,
    load_error_title: `Error al Cargar Datos`,
    load_error_message: `No podemos cargar los datos de {{assetClass}} en este momento. Por favor, intenta de nuevo.`,
    retry: `Reintentar`,
    invalidConfiguration: `Configuración no válida`,
  },
  privacy: {
    cookie_management: 'Privacidad y cookies',
    manage_cookie_preferences: 'Gestionar Preferencias de Cookies',
    review_preferences: 'Revisar preferencias',
    manage_cookie_preferences_description: 'Gestionar cookies y seguimiento.',
  },
  support: {
    get_help: 'Obtener Ayuda',
    how_can_we_help: '¿Necesita ayuda?',
    visit_our_support_site: 'Visite Soporte para preguntas frecuentes o para contactarnos.',
  },
  haptic: {
    settings_title: 'Retroalimentación Háptica',
    settings_description: 'El dispositivo vibra al tocar. No disponible en todos los dispositivos.',
    enabled: 'Retroalimentación háptica habilitada',
    disabled: 'Retroalimentación háptica deshabilitada',
  },
  work: {
    title: `Trabajo`,
    tasks: `Tareas`,
    open: `Abiertas`,
    completed: `Completadas`,
    none: `Ninguno`,
    create: {
      title: `Crear trabajo`,
      add: `Agregar tarea`,
      task_type: `Tipo de tarea`,
      task_type_required: `El tipo de tarea es obligatorio`,
      assignee: `Asignado a`,
      due_date: `Fecha de vencimiento`,
      unassigned: `Sin asignar`,
      all: `Todos`,
      no_due_date: `Sin fecha`,
      clear: `Borrar`,
      submit_error: `No se pudo crear el trabajo. Inténtelo de nuevo.`,
      add_photo: `Agregar foto`,
      remove_photo: `Eliminar foto {{name}}`,
      queued_offline: `Trabajo guardado. Se creará cuando vuelvas a estar en línea.`,
      submit_failed: `No se pudo completar {{step}} (activo {{assetId}}). El trabajo se descartó.`,
      failed_step: {
        host: `guardar el registro`,
        asset: `crear el activo`,
        work: `crear el trabajo`,
        photos: `adjuntar las fotos`,
      },
    },
    priority: {
      not_specified: `Sin especificar`,
      low: `Baja`,
      medium: `Media`,
      high: `Alta`,
      urgent: `Urgente`,
    },
  },
  work_task: {
    upload: {
      starting: `Iniciando subida...`,
      queued: `Foto en cola para subir`,
    },
  },
  arm: {
    start_basic_inspection: 'Inspección Básica',
    tree_details: 'Detalles',
    work: 'Trabajo',
    move_asset: 'Mover Activo',
    tree_history: 'Historial',
    inspection: 'Inspección',
    work_coming_soon: 'La acción de trabajo estará disponible pronto',
    history_event_basic_inspection: 'Inspección básica',
    history_event_basic_risk_assessment: 'Evaluación básica de riesgos',
    risk_assessment_on: 'Evaluación de riesgos el {{date}}',
    risk_rating: 'Calificación de Riesgo',
    risk_rating_low: 'Bajo',
    risk_rating_moderate: 'Moderado',
    risk_rating_high: 'Alto',
    risk_rating_extreme: 'Extremo',
    risk_rating_helper: 'Calculado a partir de las selecciones.',
    history_comments: 'Comentarios',
    history_no_value: '—',
    history_empty: 'Aún no hay historial para este elemento.',
    history_error: 'No se pudo cargar el historial. Inténtalo de nuevo.',
    history_photo_alt: 'Foto de inspección',
    history_photo_close: 'Cerrar',
    history_photo_load_failed: 'No se pudo cargar la imagen',
    history_sort_label: 'Orden',
    history_sort_newest: 'Más reciente primero',
    history_sort_oldest: 'Más antiguo primero',
    history_filter_all: 'Todos',
    history_filter_photos: 'Fotos',
    history_expand_all: 'Expandir todo',
    history_collapse_all: 'Contraer todo',
    history_no_filtered: 'Ningún elemento coincide con este filtro.',
    inspection_submit: 'Enviar Inspección',
    inspection_submit_success: 'Inspección enviada',
    start_basic_risk_assessment: 'Evaluación Básica de Riesgos',
    inspection_submit_error: 'No se pudo enviar la inspección. Inténtalo de nuevo.',
    inspection_missing_identifier:
      'Este elemento no se puede inspeccionar hasta que termine de sincronizarse.',
    inspection_no_fields: 'No hay campos de inspección configurados para este elemento.',
    inspection_submit_queued:
      'Inspección guardada. Se sincronizará cuando vuelvas a estar en línea.',
    inspection_notes_label: 'Notas de inspección',
    inspection_notes_placeholder: 'Agrega una nota para esta inspección (opcional)',
    risk_notes_label: 'Notas de Evaluación de Riesgos',
    risk_notes_placeholder: 'Agrega una nota para esta evaluación de riesgos (opcional)',
    back_to_forms: 'Volver a los formularios',
    form_basic_inspection: 'Inspección Básica',
    form_basic_inspection_description: 'Registra las condiciones y observaciones del árbol.',
    form_basic_risk_assessment: 'Evaluación Básica de Riesgos',
    form_basic_risk_assessment_description:
      'Evalúa el riesgo del árbol para priorizar el trabajo de seguimiento.',
    inspection_add_photo: 'Agregar foto',
    inspection_photo_limit_reached: 'Has alcanzado el número máximo de fotos.',
    asset_add_photo: 'Agregar foto',
    asset_photo_limit_reached: 'Has alcanzado el número máximo de fotos.',
    last_modified_by: 'por {{user}} el {{date}}',
    inspection_offline_banner: 'Estás sin conexión. Tu inspección se enviará cuando te reconectes.',
    form_offline_banner: 'Estás sin conexión. Tus cambios se enviarán cuando te reconectes.',
  },
  risk_assessment: {
    submit: 'Enviar evaluación de riesgos',
    submitted: 'Evaluación de riesgos enviada',
  },
  work_list: {
    filters: 'Filtros',
    filter_assigned_to: 'Asignado a',
    filter_task_type: 'Tipo de Tarea',
    filter_priority: 'Prioridad',
    filter_work_order: 'Orden de Trabajo',
    filter_all: 'Todos',
    filter_options_error: 'No se pudieron cargar opciones del servidor. Mostrando filtros locales.',
    showing_count: `Mostrando {{shown}} de {{total}} resultados`,
    apply_filters: 'Aplicar',
    clear_filters: 'Limpiar',
    error_user_id_not_available: 'ID de usuario no disponible',
    error_tenant_id_not_available: 'ID de cuenta no disponible',
    error_task_not_found: 'Tarea no encontrada',
    error_completing_work_task: 'Error al completar la tarea de trabajo',
    error_restarting_work_task: 'Error al reiniciar la tarea de trabajo',
    mark_incomplete_dialog_title: '¿Marcar Tarea como Incompleta?',
    mark_incomplete_dialog_message: 'Esto moverá la tarea de vuelta a su lista de Tareas.',
    mark_incomplete_action: 'Marcar como Incompleta',
    no_tasks: 'No hay tareas disponibles',
    no_completed_tasks: 'No hay tareas completadas',
    no_results: 'No se encontraron resultados',
    connection_warning: 'Algunas tareas no se están mostrando. Reintente con mejor conexión.',
    syncing_warning: 'Algunas tareas no se están mostrando. Sincronizando…',
    aria_region_label: 'Lista de tareas de trabajo con paginación',
    aria_pagination_nav: 'Paginación de tareas de trabajo',
    aria_pagination_controls: 'Controles de paginación, página {{currentPage}} de {{totalPages}}',
    aria_tasks_list:
      'Tareas de trabajo, mostrando {{currentItems}} de {{totalItems}} elementos (página {{currentPage}} de {{totalPages}})',
    aria_go_to_page: 'Ir a la página {{page}}',
    aria_previous_page: 'Ir a la página anterior, página {{page}}',
    aria_previous_page_disabled: 'Página anterior (deshabilitada)',
    aria_next_page: 'Ir a la página siguiente, página {{page}}',
    aria_next_page_disabled: 'Página siguiente (deshabilitada)',
    aria_task_item:
      'Tarea de trabajo {{itemNumber}} de {{totalItems}}: {{title}}, {{description}}{{workOrder}}, {{status}}',
    aria_task_completed: 'completada',
    aria_task_not_completed: 'no completada',
    aria_mark_complete: 'Marcar "{{title}}" como completada',
    aria_mark_incomplete: 'Marcar "{{title}}" como incompleta',
    aria_priority: 'Prioridad: {{priority}}',
    unable_to_load_work_tasks: `Error: No se pueden cargar las tareas de trabajo`,
    species_unknown: 'Especie Desconocida',
    show_in_map: 'Mostrar en el mapa',
    work_order: 'OT: {{name}}',
    unknown: 'Desconocido',
    photo_upload_success: 'Foto subida correctamente',
    photo_upload_error: 'Error al subir la foto',
    photos_upload_success: '{{count}} fotos subidas correctamente',
    photos_upload_error: 'Error al subir {{count}} fotos',
    photo_limit_reached: 'Límite de fotos alcanzado (máximo 5 fotos)',
    aria_add_photo: 'Añadir foto a "{{title}}"',
  },
  formPlayer: {
    error: 'Error al cargar el formulario',
    retry: 'Reintentar',
    noFields: 'Este formulario no tiene campos configurados.',
  },
  nav: {
    home: 'Inicio',
    map: 'Mapa',
    settings: 'Configuración',
  },
  forms: {
    dbh_multistem_add_stem: 'Añadir tallo',
    dbh_multistem_remove_stem: 'Quitar tallo {{number}}',
    dbh_multistem_stem_input_label: 'Diámetro del tallo {{number}}',
    dbh_multistem_stem_count_singular: '{{count}} tallo',
    dbh_multistem_stem_count_plural: '{{count}} tallos',
    dbh_multistem_stem_n_label: 'Tallo {{number}}',
    dbh_multistem_calculated_label: 'DAP calculado',
    dbh_multistem_add_stem_inline_label: '+ Tallo',
    add_new_asset: 'Agregar Nuevo Activo',
    basic_information: 'Información Básica',
    details: 'Detalles',
    location: 'Ubicación',
    coordinates: 'Coordenadas',
  },
  cancel: 'Cancelar',
  loading: 'Cargando...',
  ok: 'Aceptar',
};

export default es;
